import Main from "./components/Main";
import Navbar from "./components/Navbar";
import About from "./components/About";  
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import  Contacts from  "./components/Contacts";
import React, {useEffect} from 'react'

function App() {
  useEffect(() => {
    document.title = "Ankur Gupta"
  }, []);
  return (
    <div >
      <Navbar />
      <Main />
      <About />
      <Skills />
      <Projects />
      <Contacts />
    </div>
  );
}

export default App;
